/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { noop } from '@amazon/vinyl-util'
import { isAudiobookEntry, type Player, type PlaylistEntry } from '@amzn/amp-playback'
import { withUserSkip } from '@/playback/metrics/userSkipSignal'

/**
 * Audiobook transport next: an audiobook is a single feed entry, so next steps
 * to the next CHAPTER via the player's section-nav surface instead of skipping
 * the feed (GH parity). Returns true when it handled the entry (audiobook) so
 * the caller skips its normal feed-skip path; false for non-audiobooks.
 */
export function stepAudiobookNext(player: Player, entry: PlaylistEntry | null): boolean {
    if (!isAudiobookEntry(entry)) return false
    withUserSkip('next', () => player.sections.nextSection()).catch(noop)
    return true
}
